import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { EventType } from "../../siteManagement/eventManager";
import { DialogHelper } from "../core/util/dialogHelper";
import { Config } from "../core/config/config";
import React from "react";
export default class VacationPlanning extends React.Component<VacationPlanningProps, any> {
    private _lockId: number;
    common = new AppHelper();
    deleteEnabled = false;
    isDeleted = false;
    currentUrl: string = null;
    translations: {};
    contactsGridOptions: {};
    allocationsGridOptions: {};
    openingHoursGridOptions: {};
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    private absences: {Value: any, Name2: string}[] = null;;

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.initApp();
    }

    private initApp = () => {
        HTTPService.get("VacationPlanning/GetKennungenForVacation").then((result) => {
            this.absences = result;
        })
        this.props.context.translations = this.translations;
    }

    handleFieldChange = (field: { model: string }, value: any, dataItem = null, isInit = false) => {

        switch (field.model) {
            case "entity.Start":
                if ((value as Date) > (Helper.getValueOrDefault(this.props.entity.End, new Date()) as Date)) {
                    this.props.entity.End = value;
                }
                break;
            case "entity.End":
                if ((value as Date) < (Helper.getValueOrDefault(this.props.entity.Start, new Date()) as Date)) {
                    this.props.entity.Start = value;
                }
                break;
            case "entity.Kennung":
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private validateValues = async () => {
        const startInPast = () => {
            let start = new Date(this.props.entity.Start);
            let rawNow = new Date();
            let now = new Date(rawNow.getFullYear(), rawNow.getMonth(), rawNow.getDate());
            return (start < now);
        }
        let message: string = this.translations["WebSMS.Vacation.AbsenceIn Past"];
        if (Helper.hasValue(this.absences)) {
            let k = this.absences.find(f => f.Value == this.props.entity.Kennung)
            if (Helper.hasValue(k) && !Helper.isNullOrEmpty(k.Name2)) {
                message = message.replace("{kennung}", k.Name2);
            } else {
                message = message.replace("({kennung})", "");
            }

        } else {
            message = message.replace("({kennung})", "");
        }

        if (startInPast()) {
            let isOK = await DialogHelper.confirm(message);
            return isOK;
        } else {
            return true;
        }
    }

    private createErrorScreen = () => {
        let s = this.translations["WebSMS.Vacation.NotConnectedToARessource"];
        let aTag = '<a style="color: black;" target="_blank" rel="noopener noreferrer" href="' + (Config.baseUrl + "UserSettings/Edit") + '" >';
        s = s.replace('<a>', aTag);
        let html = '<span style="font-size: x-large;">' + s + '</span>';
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

                <span className="fa-stack fa-10x">
                    <i className="fal fa-child fa-stack-1x"></i>
                    <i className="fal fa-ban fa-stack-2x text-danger"></i>
                </span>
                <div className="content" style={{ padding: "0 250px", marginTop: "10px" }} dangerouslySetInnerHTML={{ __html: html }}></div>
            </div>
            );
    }

    save = async (closeAfterSave) => {
        if (this.common.validate() && await this.validateValues()) {
            HTTPService.post<JsonResultClass<number>>("VacationPlanning/Save", this.props.entity)
                .then((result) => {
                    switch (result.Code) {
                        case 0:
                            NotificationHelper.showSuccessMessage(result.Message);
                            General.Events.trigger(EventType.Custom, { cmd: "vacationPlanningGridReload" });
                            break;
                        case 1:
                            NotificationHelper.showErrorMessage(result.Message);
                            break;
                        case 2:
                            NotificationHelper.showWarningMessage(result.Message);
                            General.Events.trigger(EventType.Custom, { cmd: "vacationPlanningGridReload" });
                            break;
                    }
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                });
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        if (this.props.connectedToRessource)
            return <CommonApp {...props} />;
        else
            return (<>{this.createErrorScreen()}</>);
    }
};

export interface VacationPlanningProps extends AppBaseProps {
    entity: VacationPlanningEntity;
    context: VacationPlanningContext;
    connectedToRessource: boolean;
}

export interface VacationPlanningContext extends Context {
    translations: {};
}

export interface VacationPlanningEntity extends Entity{
    RessNr: string;
    End: Date | string;
    Start: Date | string;
    Kennung: any;
}
